/**
 * @generated SignedSource<<86e01cc8b0640af491bde655fd63c52b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IntegrationProvider = "ASANA" | "CLICKUP" | "HUBSPOT_TASK" | "JIRA" | "LINEAR" | "MICROSOFT_TODO" | "MONDAY" | "TRELLO";
export type ActionItemIntegrationsConnectUserMutation$variables = {
  destinationInfo: any;
  integrationProvider: IntegrationProvider;
  syncEnabled: boolean;
  triggerManualSync: boolean;
};
export type ActionItemIntegrationsConnectUserMutation$data = {
  readonly connectUserToIntegration: {
    readonly viewer: {
      readonly integrations: {
        readonly " $fragmentSpreads": FragmentRefs<"ActionItemIntegrationsUserIntegration">;
      };
    } | null;
  } | null;
};
export type ActionItemIntegrationsConnectUserMutation = {
  response: ActionItemIntegrationsConnectUserMutation$data;
  variables: ActionItemIntegrationsConnectUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "destinationInfo"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "integrationProvider"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "syncEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "triggerManualSync"
},
v4 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "destinationInfo",
        "variableName": "destinationInfo"
      },
      {
        "kind": "Variable",
        "name": "integrationProvider",
        "variableName": "integrationProvider"
      },
      {
        "kind": "Variable",
        "name": "syncEnabled",
        "variableName": "syncEnabled"
      },
      {
        "kind": "Variable",
        "name": "triggerManualSync",
        "variableName": "triggerManualSync"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionItemIntegrationsConnectUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "ConnectUserToIntegrationPayload",
        "kind": "LinkedField",
        "name": "connectUserToIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ActionItemIntegrationsUserIntegration"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ActionItemIntegrationsConnectUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "ConnectUserToIntegrationPayload",
        "kind": "LinkedField",
        "name": "connectUserToIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserActionItemIntegrationNode",
                    "kind": "LinkedField",
                    "name": "userLevelActionItemIntegration",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "integrationProvider",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "syncEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "syncedActionItemCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unsyncedActionItemCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastSyncDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "integrationSpecificDetails",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MicrosoftTodoUserNode",
                                "kind": "LinkedField",
                                "name": "microsoftTodoUser",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "fullName",
                                        "storageKey": null
                                      },
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "externalListName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "externalListId",
                                "storageKey": null
                              }
                            ],
                            "type": "MicrosoftTodoUserIntegrationNode",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v5/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5183f427348ae8fd7bef39109fc46a72",
    "id": null,
    "metadata": {},
    "name": "ActionItemIntegrationsConnectUserMutation",
    "operationKind": "mutation",
    "text": "mutation ActionItemIntegrationsConnectUserMutation(\n  $integrationProvider: IntegrationProvider!\n  $destinationInfo: JSON!\n  $syncEnabled: Boolean!\n  $triggerManualSync: Boolean!\n) {\n  connectUserToIntegration(input: {integrationProvider: $integrationProvider, destinationInfo: $destinationInfo, syncEnabled: $syncEnabled, triggerManualSync: $triggerManualSync}) {\n    viewer {\n      integrations {\n        ...ActionItemIntegrationsUserIntegration\n      }\n      id\n    }\n  }\n}\n\nfragment ActionItemIntegrationsUserIntegration on UserIntegrations {\n  userLevelActionItemIntegration {\n    id\n    integrationProvider\n    syncEnabled\n    syncedActionItemCount\n    unsyncedActionItemCount\n    lastSyncDate\n    integrationSpecificDetails {\n      __typename\n      ...MicrosoftTodoIntegrationUserIntegrationDetails\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment MicrosoftTodoIntegrationUserIntegrationDetails on MicrosoftTodoUserIntegrationNode {\n  microsoftTodoUser {\n    user {\n      fullName\n      id\n    }\n    id\n  }\n  externalListName\n  externalListId\n}\n"
  }
};
})();

(node as any).hash = "8c65739cdd9512ed175146dfc2b1e375";

export default node;
